module.exports = __webpack_public_path__ + "img/bjws.f3131806.png";